export const SECTION_LABELS = {
  registeredAttendees: "Registered attendees",
  checkInRate: "Check-in rate",
  engagementIndex: "Engagement index",
  appFeatureUsage: "App feature usage",
  sponsorReach: "Sponsor reach",
  attendeeAccess: "Attendee access",
  agendaUsage: "Agenda usage",
  profileViews: "Speaker & sponsor visibility",
  pagesUsage: "Pages usage",
  notifications: "Notifications",
  appAdoption: "App adoption",
  qrCheckIn: "QR check-in",
  inviteFunnel: "Invite funnel",
  registrations: "Registrations",
  pollsAnalysis: "Polls",
  surveysAnalysis: "Surveys",
  giveaway: "Giveaway",
  interestsTags: "Interests / tags",
  engagementSegmentation: "Engagement segmentation",
  compliance: "Compliance",
};

export const GROUP_LABELS = {
  summary: "Event summary",
  attendance: "Attendance",
  communications: "Communications",
  reach: "Reach",
  onSite: "On-site",
  registration: "Registration",
  engagement: "Engagement",
  compliance: "Compliance",
};

export const PART_LABELS = {
  attendeeAccess: {
    totalTickets: "Total tickets",
    checkedIn: "Checked in",
    checkInRate: "Check-in rate",
    checkInsOverTime: "Check-ins over time",
    appPageViews: "App page views during the event",
    viewsPerPage: "Total views per page",
  },
  agendaUsage: {
    bookmarks: "Bookmarks",
    activeAppUsers: "Active app users",
    avgSessionsFollowed: "Avg sessions followed",
    sessionsTracked: "Sessions tracked",
    mostViewedSessions: "Most viewed sessions",
    agendaViewsOverTime: "Agenda views over time",
    highestRatedSessions: "Highest rated sessions",
  },
  profileViews: {
    topSpeakers: "Top speakers",
    topSponsors: "Top sponsors",
  },
  pagesUsage: {
    activeAppUsers: "Active app users",
    openedPageRate: "Opened ≥1 page",
    pagesTracked: "Pages tracked",
    viewsPerPage: "Views per page",
  },
  notifications: {
    emailSent: "Email sent",
    emailOpenRate: "Email open rate",
    notificationsSent: "Notifications sent",
    notificationOpenRate: "Notification open rate",
    byType: "By type",
  },
  appAdoption: {
    activeAppUsers: "Active app users",
    checkedInAttendees: "Checked-in attendees",
    appActivationRate: "App activation rate",
    languageDistribution: "Language distribution",
  },
  qrCheckIn: {
    totalCheckedIn: "Total checked in",
    peakCheckInWindow: "Peak check-in window",
    checkedInFirstTwoHours: "Checked in within first 2h",
    lateArrivals: "Late arrivals",
    checkInsPerHour: "QR check-ins per hour",
    profileBreakdown: "Attendee profile breakdown",
    ticketTypeAttendance: "Attendance by ticket type",
    checkInsPerHourByDay: "Check-in per hour, per day",
  },
  registrations: {
    approvalRate: "Approval rate",
    checkInRate: "Check-in rate",
    avgHoursToCheckIn: "Avg hours to check-in",
    registrationFunnel: "Registration funnel",
    attendance: "Attendance",
    registrationsOverTime: "Registrations and tickets over time",
  },
  pollsAnalysis: {
    totalPolls: "Total polls",
    totalResponses: "Total responses",
    participants: "Participants",
    participationRate: "Participation rate",
    avgResponsesPerPoll: "Avg responses / poll",
    perPollBreakdown: "Per-poll breakdown",
  },
  surveysAnalysis: {
    totalSurveys: "Total surveys",
    totalResponses: "Total responses",
    participants: "Participants",
    participationRate: "Participation rate",
    perSurveyBreakdown: "Per-survey breakdown",
  },
  giveaway: {
    sponsors: "Sponsors",
    totalScans: "Total scans",
    participants: "Participants",
    completionRate: "Completion rate",
    mostPopularSponsor: "Most popular sponsor",
    scansPerSponsor: "Scans per sponsor",
  },
  interestsTags: {
    attendeeCategories: "Attendee categories",
    mostCommonInterests: "Most common interests",
  },
  compliance: {
    accepted: "Accepted",
    declined: "Declined",
    optedOut: "Accepted, then opted out",
    seen: "Saw the terms, did not answer",
    neverOpened: "Never opened the event in the app",
    deletedAccount: "Account deleted",
    complianceAnswers: "Compliance answers",
  },
};
